import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
const notifications = [{
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Juan',
  city: 'Buenos Aires'
}, {
  name: 'Laura',
  city: 'Rosario'
}, {
  name: 'Carlos',
  city: 'Mendoza'
}, {
  name: 'Ana',
  city: 'Tucumán'
}, {
  name: 'Diego',
  city: 'La Plata'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}, {
  name: 'Martín',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const randomIndex = Math.floor(Math.random() * notifications.length);
      setCurrentNotification(randomIndex);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(() => {
      showNotification();
      const interval = setInterval(() => {
        showNotification();
      }, 12000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-211">
      {isVisible && currentNotification !== null && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10,
      scale: 0.95
    }} className="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white text-slate-900 rounded-lg shadow-2xl p-3 z-50 flex items-start gap-3 border-l-4 border-green-500" data-id="element-212">
          <div className="bg-green-100 p-2 rounded-full mt-0.5" data-id="element-213">
            <MapPin className="w-4 h-4 text-green-600" data-id="element-214" />
          </div>
          <div className="flex-1" data-id="element-215">
            <p className="text-sm font-medium leading-tight" data-id="element-216">
              <span className="font-bold" data-id="element-217">
                {notifications[currentNotification].name}
              </span>{' '}
              de {notifications[currentNotification].city} acaba de comprar este
              sistema
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-218">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-219">
            <X className="w-4 h-4" data-id="element-220" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}